<template>
  <div>
    {{ $t("custom.results_per_page") }}

    <button
      class="-mx-px ml-2 h-9 w-10 rounded-l border border-solid border-gray-300 text-center text-sm uppercase"
      :class="[
        activeItems === 16 ? 'bg-[color:var(--color-secondary-500)] font-bold text-white' : 'bg-white font-medium',
      ]"
      type="button"
      @click="updateItemsPerPage(16)"
    >
      16
    </button>
    <button
      class="-mx-px h-9 w-10 border border-solid border-gray-300 text-center text-sm uppercase"
      :class="[
        activeItems === 32 ? 'bg-[color:var(--color-secondary-500)] font-bold text-white' : 'bg-white font-medium',
      ]"
      type="button"
      @click="updateItemsPerPage(32)"
    >
      32
    </button>
    <button
      class="-mx-px h-9 w-10 rounded-r border border-solid border-gray-300 text-center text-sm uppercase"
      :class="[
        activeItems === 48 ? 'bg-[color:var(--color-secondary-500)] font-bold text-white' : 'bg-white font-medium',
      ]"
      type="button"
      @click="updateItemsPerPage(48)"
    >
      48
    </button>
  </div>
</template>

<script setup lang="ts">
import { DEFAULT_PAGE_SIZE } from "@/core/constants";

interface IProps {
  scrollTarget?: HTMLElement | null;
  activeItems?: number;
  scrollOffset: number;
}

const props = withDefaults(defineProps<IProps>(), {
  scrollOffset: 20,
  activeItems: DEFAULT_PAGE_SIZE,
});

const emit = defineEmits(["update:itemsPerPage"]);

function updateItemsPerPage(val: number) {
  emit("update:itemsPerPage", val);

  scrollToTop();
}

function scrollToTop() {
  if (props.scrollTarget) {
    const topPosition = props.scrollTarget.getBoundingClientRect().top + window.scrollY - props.scrollOffset;
    window.scrollTo({ top: topPosition, behavior: "smooth" });
  }
}
</script>
